/**
 * Control de equipos + bloqueo por plan diario (ticket 78750).
 * Naomi + autorizados de bloqueo + jefes de área.
 */
export const IDERPS_CONTROL_EQUIPOS = [2781, 1, 334, 568, 1312, 3015, 966, 32, 28]

function menuTienePath(menu, path) {
  if (!Array.isArray(menu)) return false
  for (const top of menu) {
    for (const cat of top.items || []) {
      if (cat && cat.path === path) return true
      for (const child of cat.items || []) {
        if (child && child.path === path) return true
      }
    }
  }
  return false
}

/**
 * Inyecta Control de equipos en Administración si el usuario está en la allowlist.
 */
export function asegurarMenuControlEquipos(menu, iderp) {
  if (!IDERPS_CONTROL_EQUIPOS.includes(Number(iderp))) {
    return Array.isArray(menu) ? menu : []
  }

  const list = Array.isArray(menu) ? menu : []
  const path = 'ControlEquipos'
  if (menuTienePath(list, path)) return list

  const action = {
    title: 'Control de equipos',
    path,
    icon: 'mdi-devices',
    active: 0,
  }

  const norm = (t) => String(t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  let admin = list.find((m) => norm(m && m.title).includes('administraci'))
  if (!admin) {
    admin = { title: 'Administración', action: 'mdi-cog', active: false, items: [] }
    list.push(admin)
  }
  if (!Array.isArray(admin.items)) admin.items = []
  admin.items.push(action)
  return list
}
